const containers = document.querySelectorAll(".col-prd-var-m");
const scrollLeftButtons = document.querySelectorAll(".prvbtn");
const scrollRightButtons = document.querySelectorAll(".nxtbtn");

function updateButtonVisibility(container, prevButton, nextButton) {
  if (container.scrollWidth <= container.clientWidth) {
    prevButton.classList.add("hidden");
    nextButton.classList.add("hidden");
  } else {
    prevButton.classList.remove("hidden");
    nextButton.classList.remove("hidden");
  }
  if (container.scrollLeft === 0) {
    prevButton.classList.add("hidden");
  } else {
    prevButton.classList.remove("hidden");
  }

  if (
    container.scrollLeft + container.clientWidth >=
    container.scrollWidth - 2
  ) {
    nextButton.classList.add("hidden");
  } else {
    nextButton.classList.remove("hidden");
  }
}
containers.forEach((container, index) => {
  const scrollLeftButton = scrollLeftButtons[index];
  const scrollRightButton = scrollRightButtons[index];

  scrollLeftButton.addEventListener("click", () => {
    scrollHorizontally(container, -1); // Scroll left by one step
    updateButtonVisibility(container, scrollLeftButton, scrollRightButton);
  });

  scrollRightButton.addEventListener("click", () => {
    scrollHorizontally(container, 1); // Scroll right by one step
    updateButtonVisibility(container, scrollLeftButton, scrollRightButton);
  });
});

function scrollHorizontally(container, amount) {
  let step = container.querySelector(".prdvar-card").offsetWidth + 10;
  container.scrollLeft += amount * step;
}

document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".col-prd-var-m");
  const prevButtons = document.querySelectorAll(".prvbtn");
  const nextButtons = document.querySelectorAll(".nxtbtn");

  containers.forEach((container, index) => {
    const prevButton = prevButtons[index];
    const nextButton = nextButtons[index];

    container.addEventListener("scroll", () => {
      updateButtonVisibility(container, prevButton, nextButton);
    });

    updateButtonVisibility(container, prevButton, nextButton);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".col-prd-var-m");

  sliders.forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;

      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});

window.addEventListener("load", function () {
  let $lssSlick3 = $(
    ".product-card__info .product-card__variants-slider:not(.slick-initialized)"
  ).slick({
    slidesToShow: 5,
    dots: true,
    arrows: false,
    draggable: false,
    infinite: false,
    swipe: false,
  });

  let checking_lenght = $(".product-card__info .product-card__variants-slider");
  $.each(checking_lenght, function (key, value) {
    if ($(this).find(".slick-slide").length > 5) {
      $(this).addClass("dot-to-show");
    } else {
      $(this).addClass("dot-to-hide");
    }
  });

  $(document).on("mouseenter", ".product-card__variant-nav", function () {
    var variant_link = $(this).attr("variant_url");
    var first_image = $(this).find("img").attr("src");
    var second_image = $(this).attr("second-image");
    var main_first_image = $(this)
      .closest(".product-card__wrapper")
      .find(".product-card__featured-image-link img");
    var main_second_image = $(this)
      .closest(".product-card__wrapper")
      .find(".product-card__secondary-image-link img");
    var main_first_link = $(this)
      .closest(".product-card__wrapper")
      .find(".product-card__featured-image-link");
    var main_second_link = $(this)
      .closest(".product-card__wrapper")
      .find(".product-card__secondary-image-link");

    $(main_first_image).attr("srcset", first_image);
    $(main_second_image).attr("srcset", second_image);
    $(main_first_image).attr("src", first_image);
    $(main_second_image).attr("src", second_image);
    $(main_first_link).attr("href", variant_link);
    $(main_second_link).attr("href", variant_link);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var elements = document.querySelectorAll(
    'div[hidecolor="{{hidecoloregion}}"]'
  );
  elements.forEach(function (element) {
    element.remove();
  });
});

